import { AnalyticEventProperties, AnalyticSegmentConfig } from './types';

import segmentClient from 'Utilities/analytics/segmentClient';
import { setAnalyticsSessionId } from 'Utilities/authHelpers';
import mediator from 'Utilities/mediator';

import { ANALYTIC_SEGMENT, AnalyticsTitleType } from 'Constants/analyticsEventTypes';

let _analyticsClient: any = null;

export function initialize(config: AnalyticSegmentConfig | undefined): void {
  if (!config || config.driver === '' || config.driver === 'none') {
    return;
  }

  const analyticsType = config.driver;

  if (analyticsType === ANALYTIC_SEGMENT) {
    _analyticsClient = segmentClient;
    _analyticsClient.initialize(config.configuration);
  }

  setAnalyticsSessionId();
}

export const LogEvent = function(
  event: AnalyticsTitleType,
  properties: AnalyticEventProperties
): void {
  if (!_analyticsClient) {
    return;
  }

  _analyticsClient.track(event, properties);
};

export const setUserId = (id: string): void => {
  try {
    if (!_analyticsClient) {
      return;
    }

    _analyticsClient.identify(id);
  } catch (error) {
    console.error('Error when attempting to setUserId: ', error);
  }
};

const resetUserId = (): void => {
  try {
    if (!_analyticsClient) {
      return;
    }

    _analyticsClient.reset();
  } catch (error) {
    console.error('Error when attempting to resetUserId: ', error);
  }
};

mediator.subscribe('user:loggedOut', resetUserId);
mediator.subscribe('analytics:setUserId', setUserId);
